// 🔒
import { benefits } from "../data/trainer-benefits";

export default function TrainerBenefitsSection() {
  return (
    <section className="section trainer-benefits" id="trainer-benefits">
      <div className="container">
        <div className="section-heading trainer-benefits__heading">
          <p className="eyebrow">TRAINER BENEFITS</p>
          <h2>Why trainers choose to build with us</h2>
          <p className="section-copy">
            Our platform helps coaches grow their brand, monetize their
            expertise, and deliver premium digital programs without dealing with
            product complexity or technical setup.
          </p>
        </div>

        <div className="trainer-benefits__layout">
          <div className="trainer-benefits__highlight">

            <p className="trainer-benefits__highlightLabel">Your advantage</p>
            <h3>Simple collaboration. Strong upside.</h3>
            <p className="trainer-benefits__highlightText">
              Elefit gives trainers a simpler way to turn their expertise into a premium 
              digital fitness product. You focus on coaching, content, and your audience. 
              We handle the setup, product experience, presentation, and ongoing platform 
              support so you can scale with less friction.
            </p>

            <div className="trainer-benefits__numbers">
              <div className="trainer-benefits__numberCard">
                <span className="trainer-benefits__number">75%</span>
                <span className="trainer-benefits__numberLabel">
                  Revenue kept by trainer
                </span>
              </div>

              <div className="trainer-benefits__numberCard">
                <span className="trainer-benefits__number">Full</span>
                <span className="trainer-benefits__numberLabel">
                  Service platform support
                </span>
              </div>
            </div>
          </div>

          <div className="trainer-benefits__grid">
            {benefits.map((benefit) => (
              <article key={benefit.id} className="trainer-benefit-card">
                <p className="trainer-benefit-card__eyebrow">
                  {benefit.eyebrow}
                </p>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
// 🔒